export default "__VITE_ASSET__D9SZEB8F__"